export default __webpack_public_path__ + "static/media/Tech-Blog.3538043a.PNG";